import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import getActiveCampaignId from '../CampaignSchedule/utils/getActiveCampaignId';
import { getPermissions } from '../../utils/getPermissions';
import { closeNav, openNav } from '../../utils/navigationToggle';
import DropDown from '../DropDown/DropDown';
import { launchCreator } from '../../utils/launchCreator';
import { classNames } from '../../utils/v4/utils';
import DeployAll from '../DeployAll/DeployAll';
import ProtectedLink from '../ProtectedLink/ProtectedLink';

class Navigation extends Component {
  showHelpTogglerRef = React.createRef();

  showResourcesTogglerRef = React.createRef();

  showAdminTogglerRef = React.createRef();

  showAssignmentsDropDownTogglerRef = React.createRef();

  showDevicesDropDownTogglerRef = React.createRef();

  state = {
    showHelpDropDown: false,
    showAssignmentDropDown: false,
    showResources: false,
    showAdmin: false,
    showDevicesDropDown: false,
  };

  componentDidMount() {
    if (globalThis) {
      this.onResize();

      globalThis.addEventListener('resize', this.onResize);
    }
  }

  componentWillUnmount() {
    if (globalThis) {
      globalThis.removeEventListener('resize', this.onResize);
    }
  }

  onResize = () => {
    const smallDesktopBreakpoint = 1024;
    const isSmallView = window.innerWidth < smallDesktopBreakpoint;

    if (process.env.NODE_ENV !== 'test') {
      // this piece of code is running during the loading of the application and breaks the tests
      // so this will make it only run when it is not in the test environment
      if (isSmallView) {
        closeNav();
      } else {
        openNav();
      }
    }
  };

  getActiveCampaignUrl = locationSearch => {
    const {
      campaignSchedule: {
        campaignSchedule: { campaignScheduleEntries },
      },
    } = this.props;
    const id = getActiveCampaignId(campaignScheduleEntries);

    return id ? `/campaigns/${id}/assignments${locationSearch}` : '';
  };

  getLinkProps = url => ({
    activeClassName: 'active',
    isActive: (match, location) => url === location.pathname + location.search,
    to: url,
  });

  getLocationSearch = userLocation =>
    `?parent=${userLocation ? encodeURIComponent(userLocation) : '/'}*`;

  toggleHelp = () => {
    this.setState(prev => ({
      showHelpDropDown: !prev.showHelpDropDown,
    }));
  };

  toggleResources = () => {
    this.setState(prev => ({
      showResources: !prev.showResources,
    }));
  };

  toggleAdmin = () => {
    this.setState(prev => ({
      showAdmin: !prev.showAdmin,
    }));
  };

  hideResources = () => {
    this.setState({ showResources: false });
  };

  hideAdmin = () => {
    this.setState({ showAdmin: false });
  };

  hideHelp = () => {
    this.setState({ showHelpDropDown: false });
  };

  hideAssignments = () => {
    this.setState({ showAssignmentDropDown: false });
  };

  toggleShowAssignment = () => {
    this.setState(prev => ({
      showAssignmentDropDown: !prev.showAssignmentDropDown,
    }));
  };

  hideDevices = () => {
    this.setState({ showDevicesDropDown: false });
  };

  toggleDevices = () => {
    this.setState(prev => ({
      showDevicesDropDown: !prev.showDevicesDropDown,
    }));
  };

  render() {
    const {
      showHelpDropDown,
      showAssignmentDropDown,
      showResources,
      showAdmin,
      showDevicesDropDown,
    } = this.state || {};
    const { user, deployer, constants } = this.props;
    const locationSearch = this.getLocationSearch(user.user.userLocation);
    const currentAssignment = this.getActiveCampaignUrl(locationSearch);
    const p = getPermissions({ user });

    return (
      <nav className="navigation-open">
        <div className="w-[240px] min-h-screen  bg-gradient-to-b from-[#FF5E00] to-[#FE3434] flex flex-col items-center">
          <img
            src="/assets/images/icons/signstix_director_nav.png"
            alt="device_logo"
            className="w-full h-[99px]"
            draggable={false}
          />
          <ul data-test="nav-sidebar-ul">
            <li>
              <DeployAll deployer={deployer} user={user} />
            </li>

            <li>
              <NavLink
                className={isActive =>
                  classNames(
                    'flex justify-center items-center mt-4 w-full',
                    isActive ? 'shadow-md' : '',
                  )
                }
                to="/home"
                data-test="side-nav-home"
              >
                <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/black_house_icon.svg"
                    alt="home icon"
                    draggable={false}
                  />
                  <p className="w-[144px] font-[700] poppins-bold text-white mb-[0px] mb-0">HOME</p>
                </div>
              </NavLink>
            </li>

            {p.contentViewer && p.atLeastTierPro && (
              <li>
                <NavLink
                  {...this.getLinkProps('/content?parent=/*&sort=createdDate+desc')}
                  className={isActive =>
                    classNames(
                      'flex justify-center items-center mt-4 w-full',
                      isActive ? 'shadow-md' : '',
                    )
                  }
                  data-test="side-nav-content"
                >
                  <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                    <img
                      className="w-[27.96px] h-[25.31px]"
                      src="/assets/images/icons/black_nav_content.svg"
                      alt="content icon"
                      draggable={false}
                    />
                    <span className="w-[144px] font-[700] poppins-bold text-white mb-0">
                      CONTENT
                    </span>
                  </div>
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                {...this.getLinkProps('/templates')}
                className={isActive =>
                  classNames(
                    'flex justify-center items-center mt-4 w-full',
                    isActive ? 'shadow-md' : '',
                  )
                }
                data-test="side-nav-templates"
              >
                <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/templates.png"
                    alt="templates icon"
                    draggable={false}
                  />
                  <span className="w-[144px] font-[700] poppins-bold text-white mb-0">
                    TEMPLATES
                  </span>
                </div>
              </NavLink>
            </li>

            <li>
              <ProtectedLink
                to="/multi-media-wizard"
                activeClass="shadow-md"
                className="flex justify-center items-center mt-4 w-full"
                data-test="side-nav-wizard"
                nav
                allowed
              >
                <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/wand_icon.svg"
                    alt="wizard icon"
                    draggable={false}
                  />
                  <span className="w-[144px] font-[700] poppins-bold text-white mb-0">WIZARD</span>
                </div>
              </ProtectedLink>
            </li>

            {(p.deviceViewer || (p.contentViewer && p.atLeastTierPro)) && (
              <li>
                <button
                  ref={this.showDevicesDropDownTogglerRef}
                  type="button"
                  className="flex appearance-none hover:shadow-md items-center p-2 space-x-2 duration-200 mt-4 w-full"
                  onClick={this.toggleDevices}
                  data-test="side-nav-devices"
                >
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/devices_nav.png"
                    alt="devices icon"
                    draggable={false}
                  />
                  <p
                    data-test="navigation-devices-span"
                    className="w-[144px] text-left font-[700] poppins-bold text-white mb-0"
                  >
                    DEVICES
                  </p>
                </button>

                <DropDown
                  show={showDevicesDropDown}
                  hide={this.hideDevices}
                  togglerRef={this.showDevicesDropDownTogglerRef}
                  useRel
                >
                  <div className="ml-14">
                    {p.deviceViewer && (
                      <NavLink
                        to={`/devices${locationSearch}`}
                        className={isActive =>
                          classNames(
                            'flex justify-center items-center mt-4 w-full',
                            isActive ? 'shadow-md' : '',
                          )
                        }
                        data-test="side-nav-devices-list"
                      >
                        <div className="flex hover:shadow-md justify-center items-center p-2 space-x-2 duration-200">
                          <span className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                            List
                          </span>
                        </div>
                      </NavLink>
                    )}
                    {p.contentViewer && p.atLeastTierPro && (
                      <NavLink
                        {...this.getLinkProps('/dashboard')}
                        className={isActive =>
                          classNames(
                            'flex justify-center items-center mt-2 w-full',
                            isActive ? 'shadow-md' : '',
                          )
                        }
                        data-test="side-nav-devices-dashboard"
                      >
                        <div className="flex hover:shadow-md justify-center items-center p-2 space-x-2 duration-200">
                          <span className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                            Dashboard
                          </span>
                        </div>
                      </NavLink>
                    )}
                  </div>
                </DropDown>
              </li>
            )}

            {p.contentViewer && (
              <li>
                <button
                  ref={this.showAssignmentsDropDownTogglerRef}
                  type="button"
                  className="flex appearance-none hover:shadow-md items-center p-2 space-x-2 duration-200 mt-4 w-full"
                  onClick={() => {
                    this.toggleShowAssignment();
                  }}
                  data-test="side-nav-assignments"
                >
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/black_nav_assignment.svg"
                    alt="assignment icon"
                    draggable={false}
                  />
                  <p className="w-[144px] text-left font-[700] poppins-bold text-white mb-0">
                    ASSIGNMENTS
                  </p>
                </button>

                <DropDown
                  show={showAssignmentDropDown}
                  hide={this.hideAssignments}
                  togglerRef={this.showAssignmentsDropDownTogglerRef}
                  useRel
                >
                  <div className="ml-14 ">
                    {currentAssignment && (
                      <NavLink
                        to={currentAssignment}
                        className="flex justify-center items-center mt-2 w-full"
                        data-test="side-nav-assignments-active"
                      >
                        <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                          <span className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                            Active Campaign
                          </span>
                        </div>
                      </NavLink>
                    )}
                    {p.atLeastTierPro && (
                      <NavLink
                        to="/campaign-schedule"
                        className={isActive =>
                          classNames(
                            'flex justify-center items-center mt-4 w-full',
                            isActive ? 'shadow-md' : '',
                          )
                        }
                        data-test="side-nav-assignments-schedule"
                      >
                        <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                          <span className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                            Campaign Schedule
                          </span>
                        </div>
                      </NavLink>
                    )}
                  </div>
                </DropDown>
              </li>
            )}

            {p.atLeastTierPro && (
              <li>
                <ProtectedLink
                  allowed
                  toolText="for Enterprise users"
                  nav
                  className="flex justify-center items-center mt-4 w-full"
                  to="/edd"
                  data-test="side-nav-edd"
                  activeClass="shadow-md"
                >
                  <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                    <img
                      className="w-[27.96px] h-[25.31px]"
                      src="/assets/images/icons/crown_icon.svg"
                      alt="edd icon"
                      draggable={false}
                    />
                    <span className="w-[144px] font-[700] poppins-bold text-white mb-0">EDD</span>
                  </div>
                </ProtectedLink>
              </li>
            )}

            {p.contentViewer && p.atLeastTierPro && (
              <li>
                <NavLink
                  to="/signsense"
                  className={isActive =>
                    classNames(
                      'flex justify-center items-center mt-4 w-full',
                      isActive ? 'shadow-md' : '',
                    )
                  }
                  data-test="side-nav-signsense"
                >
                  <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                    <img
                      className="w-[27.96px] h-[25.31px]"
                      src="/assets/images/icons/sign_sense.png"
                      alt="signsense icon"
                      draggable={false}
                    />
                    <span className="w-[144px] font-[700] poppins-bold text-white mb-0">
                      SIGNSENSE
                    </span>
                  </div>
                </NavLink>
              </li>
            )}

            {p.atLeastTierPro && (
              <li>
                <button
                  ref={this.showResourcesTogglerRef}
                  type="button"
                  className="flex appearance-none hover:shadow-md items-center p-2 space-x-2 duration-200 mt-4 w-full"
                  onClick={this.toggleResources}
                  data-test="side-nav-modules"
                >
                  <img
                    className="w-[27.96px] h-[25.31px]"
                    src="/assets/images/icons/black_nav_resources.svg"
                    alt="modules icon"
                    draggable={false}
                  />
                  <p className="w-[144px] text-left font-[700] poppins-bold text-white mb-0">
                    MODULES
                  </p>
                </button>

                <DropDown
                  show={showResources}
                  hide={this.hideResources}
                  togglerRef={this.showResourcesTogglerRef}
                  useRel
                >
                  <div className="ml-14 ">
                    <NavLink
                      to="/fonts"
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center mt-4 w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-modules-fonts"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">Fonts</p>
                      </div>
                    </NavLink>
                    <NavLink
                      to="/data-objects"
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-modules-dataobjects"
                    >
                      <div className="hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200 hidden">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">
                          Data Objects
                        </p>
                      </div>
                    </NavLink>
                    <NavLink
                      to="/url-rulesets"
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center mt-4 w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-modules-urlrulesets"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">
                          URL Rulesets
                        </p>
                      </div>
                    </NavLink>
                  </div>
                </DropDown>
              </li>
            )}

            {p.atLeastTierProOrSuperUser && p.admin && (
              <li>
                <button
                  ref={this.showAdminTogglerRef}
                  type="button"
                  className="flex appearance-none hover:shadow-md items-center p-2 space-x-2 duration-200 mt-4 w-full"
                  onClick={this.toggleAdmin}
                  data-test="side-nav-admin"
                >
                  <img
                    className="w-[27.96px] h-[25.31px] text-[#0A364B]"
                    src="/assets/images/icons/admin_settings.png"
                    alt="admin icon"
                    draggable={false}
                  />
                  <p className="w-[144px] text-left font-[700] poppins-bold text-white mb-0">
                    ADMIN
                  </p>
                </button>

                <DropDown
                  show={showAdmin}
                  hide={this.hideAdmin}
                  togglerRef={this.showAdminTogglerRef}
                  useRel
                >
                  <div className="ml-14 ">
                    <NavLink
                      to="/users"
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center mt-4 w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-admin-users"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">Users</p>
                      </div>
                    </NavLink>
                    <NavLink
                      to={`/locations${locationSearch}`}
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center mt-4 w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-admin-locations"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">
                          Locations
                        </p>
                      </div>
                    </NavLink>
                    <NavLink
                      to="/map"
                      className={isActive =>
                        classNames(
                          'flex justify-center items-center mt-4 w-full',
                          isActive ? 'shadow-md' : '',
                        )
                      }
                      data-test="side-nav-admin-map"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0">Map</p>
                      </div>
                    </NavLink>
                    {p.atLeastTierPro && (
                      <NavLink
                        to="/roles"
                        className={isActive =>
                          classNames(
                            'flex justify-center items-center mt-4 w-full',
                            isActive ? 'shadow-md' : '',
                          )
                        }
                        data-test="side-nav-admin-roles"
                      >
                        <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                          <p className="w-[144px] font-[700] poppins-bold text-white mb-0">Roles</p>
                        </div>
                      </NavLink>
                    )}
                    {p.atLeastTierPro && (
                      <NavLink
                        to="/tagmanager"
                        className={isActive =>
                          classNames(
                            'flex justify-center items-center mt-4 w-full',
                            isActive ? 'shadow-md' : '',
                          )
                        }
                        data-test="side-nav-admin-tagmanager"
                      >
                        <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                          <p className="w-[144px] font-[700] poppins-bold text-white mb-0">
                            Tag Manager
                          </p>
                        </div>
                      </NavLink>
                    )}
                  </div>
                </DropDown>
              </li>
            )}

            <li>
              <button
                ref={this.showHelpTogglerRef}
                type="button"
                className="flex appearance-none hover:shadow-md items-center p-2 space-x-2 duration-200 mt-4 w-full"
                onClick={this.toggleHelp}
                data-test="side-nav-help"
              >
                <img
                  className="w-[27.96px] h-[25.31px]"
                  src="/assets/images/icons/black_nav_help.svg"
                  alt="help icon"
                  draggable={false}
                />
                <p className="w-[144px] text-left font-[700] poppins-bold text-white mb-0">HELP</p>
              </button>

              <DropDown
                show={showHelpDropDown}
                hide={this.hideHelp}
                togglerRef={this.showHelpTogglerRef}
                useRel
              >
                <div className="ml-14 ">
                  {constants.help_support_link && (
                    <a
                      href={constants.help_support_link}
                      target="_blank"
                      className="flex justify-center items-center mt-2 w-full"
                      rel="noopener noreferrer"
                      data-test="side-nav-help-support"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                          Support
                        </p>
                      </div>
                    </a>
                  )}
                  {constants.help_tutorials_link && (
                    <a
                      href={constants.help_tutorials_link}
                      target="_blank"
                      className="flex justify-center items-center mt-4 w-full"
                      rel="noopener noreferrer"
                      data-test="side-nav-help-tutorials"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                          Tutorials
                        </p>
                      </div>
                    </a>
                  )}
                  {p.atLeastTierPro && (
                    <ProtectedLink
                      allowed={p.atLeastTierEnterprise}
                      toolText="for Enterprise users"
                      nav={false}
                      to="/docs/api/v1/reference.html"
                      external
                      target="_blank"
                      className="flex justify-center items-center mt-4 w-full"
                      rel="noopener noreferrer"
                      data-test="side-nav-help-apidocs"
                    >
                      <div className="flex  hover:shadow-md  justify-center items-center p-2 space-x-2 duration-200">
                        <p className="w-[144px] font-[700] poppins-bold text-white mb-0 text-[13px]">
                          API Docs
                        </p>
                      </div>
                    </ProtectedLink>
                  )}
                </div>
              </DropDown>
            </li>
          </ul>
          <ul style={{ marginTop: 'auto', marginBottom: '20px' }}>
            {p.atLeastTierProOrSuperUser && p.admin && (
              <li>
                <button
                  type="button"
                  onClick={() => launchCreator()}
                  className="mt-4 w-[195.95px]  h-[50px] bg-[#00243E] rounded-lg text-white font-[700] poppins-bold
          hover:bg-transparent hover:shadow-md duration-200 active:bg-[#00243E] 
           hover:scale-105 flex items-center justify-center space-x-2 text-[24px]"
                  data-test="side-nav-creator"
                >
                  <span className="text-inherit">CREATOR</span>
                  <i
                    aria-label="creator"
                    className="fa !static fa-paint-brush w-[30px] h-[30px] !text-white"
                  />
                </button>
              </li>
            )}
          </ul>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = state => {
  return {
    constants: state.constants?.data || {},
  };
};

export default withRouter(connect(mapStateToProps)(Navigation));

Navigation.propTypes = {
  user: PropTypes.object,
  uploading: PropTypes.array.isRequired,
  campaignSchedule: PropTypes.object.isRequired,
  deployer: PropTypes.func.isRequired,
  showNotificationHistory: PropTypes.func.isRequired,
  history: PropTypes.object,
  constants: PropTypes.shape({
    help_support_link: PropTypes.string,
    help_tutorials_link: PropTypes.string,
  }),
};
